import { AppApi } from "../../apis/app.api";
import { LeadApi } from "../../apis/lead.api";
import { defaultLeadProfile } from "../../constants/data.constant";
import { TAddUpdateLeadName } from "../../models/add-update-lead-request";
import { TLastPageRequest } from "../../models/last-update-page-request";
import { TUpdateLeadStrategy } from "../../models/update-lead";
import { withRxJs } from "../hoc/with-rx";
import { AboutYouComponent } from "./aboutyou.component";

const AboutYouContainer = withRxJs(AboutYouComponent)(() => {
	// const user$ = UserApi.getUser().map(value => value.toOption());
	//.do(user => user.map(u => LeadApi.advisorId$.next(u.roles[0].aplId.getOrElse(''))));
	return {
		defaultProps: {
			leadData: defaultLeadProfile,
			leadStrategy: { investmentAmount: 0, investmentReason: '2' },
			onAddUpdateName: (lead: TAddUpdateLeadName, lastPage: TLastPageRequest, leadId: string) => {
				if (leadId) {
					LeadApi.updateLeadAbout(lead, lastPage, leadId);
				} else {
					LeadApi.addLeadAbout(lead, lastPage);
				}
			},
			onAddUpdateAmountReason: (lead: TUpdateLeadStrategy, lastPage: TLastPageRequest) => {
				LeadApi.updateLeadAmountAndReason(lead, lastPage);
			},
			onBackButtonClick: (backScreen: string) => {
				LeadApi.redirectToPage$.next(backScreen);
			},
		},
		props: {
			leadData: LeadApi.getSavedLeadProfile$(),
			leadStrategy: LeadApi.getSavedLeadStrategy$(),
		},
	};
});

export default AboutYouContainer;